import React from "react";
// Utility function to get appropriate loader based on domain/tenant
import { getAppropriateLoader } from "../../../utils/loaderUtils";
import classes from "./PageLoader.module.scss";

const PageLoader = ({ message }) => {
  // Get the appropriate loader (LTM for lighthouse.ltm.com, default for others)
  const selectedLoader = getAppropriateLoader();

  return (
    <div className={classes.loader_container}>
      {/* <div className={classes.loader}></div> */}
      {/* 
        Conditional loader display using loaderUtils:
        - LTM_Loader 1.gif for lighthouse.ltm.com domain
        - Default loader-6.gif for all other domains
      */}
      <img src={selectedLoader} className={classes.loader__gif} alt="loading" />
      {/* Only show message if explicitly provided */}
      {message && <div className={classes.loader__message}>{message}</div>}
    </div>
  );
};

export default PageLoader;
